var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-player-v2"},[_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }